import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { SiteAssociationInitializerService } from '@libs/site-association';
import { Observable } from 'rxjs';

export const SiteAssociationGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> => {
  return inject(SiteAssociationInitializerService).checkSiteAssociationEmail$(next, state);
};
